function handleCollectionBreadcrumb() {
	// Store collection info when clicking product links on collection pages
	if (window.location.pathname.includes('/collections/')) {
		function setupCollectionTracking() {
			const productLinks = document.querySelectorAll('a[href*="/products/"]');
			
			productLinks.forEach(link => {
				link.addEventListener('click', () => {
					const currentPath = window.location.pathname;
					
					// Get collection title from various possible locations
					const collectionTitle = 
						document.querySelector('.collection__title .hero__title')?.textContent?.trim() ||
						document.querySelector('.section-header__title.collection-title')?.textContent?.trim() ||
						document.querySelector('.collection-title')?.textContent?.trim() ||
						document.querySelector('.page-title')?.textContent?.trim() ||
						document.querySelector('.qck-hero-title')?.textContent?.trim() ||
						document.querySelector('h1')?.textContent?.trim() ||
						formatCollectionTitle(currentPath);
					
					if (collectionTitle) {
						sessionStorage.setItem('collection_title', collectionTitle);
						sessionStorage.setItem('collection_url', currentPath);
					}
				});
			});
		}

		// Setup tracking when DOM is ready
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', setupCollectionTracking);
		} else {
			setupCollectionTracking();
		}
	}

	// Handle product page breadcrumb rendering
	if (window.location.pathname.includes('/products/')) {
		setTimeout(() => {
			const productTitle = document.querySelector('.breadcrumbs [data-product-title]')?.textContent?.trim();
			const previousProductTitle = sessionStorage.getItem('product_title');
			const collectionTitle = sessionStorage.getItem('collection_title');

			if (collectionTitle) {
				if (previousProductTitle && productTitle !== previousProductTitle) {
					// Different product, clear session storage
					sessionStorage.removeItem('product_title');
					sessionStorage.removeItem('collection_title');
					sessionStorage.removeItem('collection_url');
				} else {
					// Same product or first time from collection
					if (productTitle) {
						sessionStorage.setItem('product_title', productTitle);
					}
					renderCollectionBreadcrumb();
				}
			}
		}, 100);
	} else {
		// Not on product page, clear session storage
		sessionStorage.removeItem('product_title');
		sessionStorage.removeItem('collection_title');
		sessionStorage.removeItem('collection_url');
	}
}

function renderCollectionBreadcrumb() {
	const collectionTitle = sessionStorage.getItem('collection_title');
	const collectionUrl = sessionStorage.getItem('collection_url');
	
	if (!collectionTitle || !collectionUrl) return;

	const breadcrumbContainer = document.querySelector('#dynamic-collection-breadcrumb');
	
	if (breadcrumbContainer) {
		breadcrumbContainer.innerHTML = '<a href="' + collectionUrl + '">' + collectionTitle + '</a><span class="breadcrumbs-sep">›</span>';
	}
}

function formatCollectionTitle(path) {
	// Extract collection handle from path and format as title
	const match = path.match(/\/collections\/([^\/\?]+)/);
	if (match && match[1]) {
		return match[1]
			.replace(/-/g, ' ')
			.replace(/\b\w/g, l => l.toUpperCase());
	}
	return 'Collection';
}

// Handle browser back/forward navigation (for pages loaded from cache)
window.addEventListener('pageshow', (event) => {
	// If on a collection page, reinitialize collection tracking
	if (window.location.pathname.includes('/collections/')) {
		handleCollectionBreadcrumb();
	}
});

// Initialize when DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		handleCollectionBreadcrumb();
		// Render collection breadcrumb on product pages
		if (window.location.pathname.includes('/products/')) {
			setTimeout(renderCollectionBreadcrumb, 100);
		}
	});
} else {
	handleCollectionBreadcrumb();
	// Render collection breadcrumb on product pages
	if (window.location.pathname.includes('/products/')) {
		setTimeout(renderCollectionBreadcrumb, 100);
	}
}
